"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var React = require('react');
var ReactDOM = require('react-dom');
var react_1 = require('react');
var MuiThemeProvider_1 = require('material-ui/styles/MuiThemeProvider');
var injectTapEventPlugin = require('react-tap-event-plugin');
var getMuiTheme_1 = require('material-ui/styles/getMuiTheme');
var lightBaseTheme_1 = require('material-ui/styles/baseThemes/lightBaseTheme');
var react_router_1 = require('react-router');
var firebase = require('firebase');
var egg_1 = require('./egg/egg');
var trader_1 = require('./trader/trader');
var history_1 = require('history');
var ReactGA = require('react-ga');
require('./style.scss');
injectTapEventPlugin();
ReactGA.initialize('UA-52298431-4');
firebase.initializeApp({
    apiKey: 'AIzaSyB1Uy7N_EMxUFEytIgUjf9nFoap2vuS_BM',
    authDomain: 'pokemongo-trading.firebaseapp.com',
    databaseURL: 'https://pokemongo-trading.firebaseio.com',
    storageBucket: 'pokemongo-trading.appspot.com',
});
var Main = (function (_super) {
    __extends(Main, _super);
    function Main() {
        _super.apply(this, arguments);
    }
    Main.prototype.render = function () {
        return React.createElement("div", null, this.props.children);
    };
    return Main;
}(react_1.Component));
lightBaseTheme_1.default.palette.primary1Color = '#1D83C1';
var App = (function (_super) {
    __extends(App, _super);
    function App() {
        _super.apply(this, arguments);
    }
    App.prototype.render = function () {
        return (React.createElement(MuiThemeProvider_1.default, {muiTheme: getMuiTheme_1.default(lightBaseTheme_1.default)}, React.createElement(react_router_1.Router, {history: react_router_1.useRouterHistory(history_1.createHashHistory)({ queryKey: false }), onUpdate: function () {
            ReactGA['set']({ page: window.location.pathname });
            ReactGA.pageview(window.location.pathname);
        }}, React.createElement(react_router_1.Route, {path: "/", component: Main}, React.createElement(react_router_1.IndexRoute, {component: egg_1.default}), React.createElement(react_router_1.Route, {path: "egg", component: egg_1.default}), React.createElement(react_router_1.Route, {path: "trader", component: trader_1.default})))));
    };
    return App;
}(react_1.Component));
ReactDOM.render(React.createElement(App, null), window['app']);



/*****************
 ** WEBPACK FOOTER
 ** ./src/main.tsx
 ** module id = 0
 ** module chunks = 0
 **/